import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/themetwo/back.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "chatText" }

import { ContactServiceData, goToUrl } from '@/view/profile/supportScript';
import { ref, computed } from 'vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'contactServicePopup',
  props: {
    dataSet: {}
  },
  emits: ['open', 'close', 'update:show'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emits = __emit

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}

__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    round: "",
    position: "right",
    onClickOverlay: _cache[1] || (_cache[1] = () => close()),
    style: {
        width: '65%',
        minHeight: '100%',
        background: '#3b372b',
        backgroundColor: '#221b24',
        zIndex: '10002',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_row, {
          class: "title",
          style: {"display":"flex","justify-content":"center","align-items":"center"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "3" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  onClick: close
                })
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "21",
              style: {"display":"flex","justify-content":"center","align-items":"center"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.ContactService')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.serviceList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "serviceCard",
            key: index
          }, [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "avatarImage"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: item.avatar,
                      alt: ""
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "serviceTitle"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.nickname), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "8",
                  style: {"display":"flex","align-items":"center","justify-content":"right"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "chat_btn",
                      onClick: ($event: any) => (_unref(goToUrl)(item.redirectUrl))
                    }, "Chat", 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('contactService.text')), 1)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})